import {Button, Chip, Typography} from "@material-tailwind/react";
import React, {useContext, useState} from "react";
import Dict from "../../helper/dict";
import {ServiceContext} from "./service_context";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {TableHead} from "../system/thead";
import TableTdContent from "../system/tableTdContent";


const TABLE_HEAD = ["#", "مباشر", "گرایش", "روز انجام خدمت", "وضعیت", "موضوع", "چالش", "گزارش پیشرفت", "عملیات"];

export function PersonServiceGrid({
                                    PersonServices,
                                    setSortBy,
                                    sortType,
                                    setSortType
                                  }) {

  const {setService, setModalOpen, setStep} = useContext(ServiceContext);

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "مباشر": "agent_name",
    "گرایش": "field_title",
    "روز انجام خدمت": "day",
    "وضعیت": "status",
    "موضوع": "topic",
    "چالش": "challenge",
    "گزارش پیشرفت": "",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "مباشر": true,
    "گرایش": true,
    "روز انجام خدمت": true,
    "وضعیت": true,
    "موضوع": true,
    "چالش": true,
    "گزارش پیشرفت": false,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {PersonServices.map(
          ({
             id,
             title,
             agent_name,
             agent_family,
             field_title,
             branch_title,
             day,
             status,
             topic,
             challenge
           }, index) => {
            const isLast = index === PersonServices.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>
                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={`${classes}`}>
                  <TableTdContent content={`${agent_name} ${agent_family}`}/>
                </td>

                <td className={`${classes}`}>
                  <TableTdContent content={`${field_title} ${branch_title}`}/>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(day, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="ghost"
                      color={status === "new" ? "amber" : status === "rejected" ? "red" : status === "payment" ? "blue" : "amber"}
                      size="sm"
                      value={Dict(`${status}`)}
                    />
                  </div>
                </td>

                <td className={`${classes}`}>
                  <TableTdContent content={topic}/>
                </td>

                <td className={`${classes}`}>
                  <TableTdContent content={challenge}/>
                </td>

                <td className={classes}
                    style={{whiteSpace: 'nowrap'}}
                >
                  <Button variant="text" onClick={() => {
                    setService(PersonServices[index]);
                    setStep("report")
                    setModalOpen(true);
                  }}
                  >
                    گزارش پیشرفت
                  </Button>
                </td>

                <td className={classes}
                    style={{whiteSpace: 'nowrap'}}
                >
                  {status === "waiting" &&
                    <Button variant="outlined" onClick={() => {
                      setService(PersonServices[index]);
                      setStep("check")
                      setModalOpen(true);
                    }}
                    >
                      مشاهده/پرداخت
                    </Button>
                  }
                  {status !== "finish" && status !== "waiting" &&
                    <Button variant="outlined" onClick={() => {
                      setService(PersonServices[index]);
                      setStep("check")
                      setModalOpen(true);
                    }}
                    >
                      مشاهده/تکمیل مدارک
                    </Button>
                  }
                  {status == "finish" &&
                    <Button variant="outlined" onClick={() => {
                      setService(PersonServices[index]);
                      setStep("check")
                      setModalOpen(true);
                    }}
                    >
                      مشاهده
                    </Button>
                  }
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  )
    ;
}